/**
 * Sum the number of elements stored in an array.
 * @returns The sum of elements in the array.
 */
export const sumOfElements = (elements: number[]): number => {
    return elements.reduce((partialSum, nextElement) => partialSum + nextElement, 0);
};
